import {Component, inject} from '@angular/core';
import {LoadingService} from "../../../shared/services/loading.service";
import {AsyncPipe} from "@angular/common";

@Component({
    selector: 'app-loading-indicator',
    imports: [
        AsyncPipe
    ],
    templateUrl: './loading-indicator.component.html',
    styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent {
  public loadingService: LoadingService = inject(LoadingService);


  protected readonly LoadingService: typeof LoadingService = LoadingService;
}
